module.exports = __webpack_public_path__ + "img/coffee.29e9c608.svg";